export interface BackOfficeAuditFilter {
  userId: string;
  action: string;
  barcode: string;
  workOrderNumber: string;
  createDateStart: string;
  createDateEnd: string;
  sort: string;
}

// backoffice-action-state.constants.ts
export const BackofficeActionState: string[] = [
  'ADD',
  'MODIFY',
  'DELETE',
  'PROCESS_CODE',
  'WORK_ORDER',
  'CUSTOMER',
  'CIRCUMFERENCE',
  'MISC_CHARGE',
  'REPAIR',
  'TREAD_TYPE',
  'TREAD_WIDTH',
  'CURE_TYPE',
  'CAM_IGNORE',
  'WHEEL_COLOR',
  'WHEEL_TYPE',
  'MAKE',
  'SERIES',
  'SIZE',
  'DEPTH',
  'APPLICATION',
  'AXLE',
  'GRADE',
  'REMAINING_TREAD_DEPTH',
  'NTR',
  'MDOT',
  'RTDOT',
  'BRAND_NUM',
  'CASING_NOTE',
  'WOHNUM',
  'SITE',
  'PLANT',
  'RECEIVED_DATE',
  'DUE_DATE',
  'CRN',
  'CREATE_WOH',
  'CREATE_WOL',
  'PRODUCTION_CUST',
  'OVERRIDE_GRADE',
  'CASING_VALUE',
  'CASING_ID'
];

/** Dropdown option: `key` is the value searched on, `label` is the display text. */
export interface BackofficeActionOption {
  key: string;
  label: string;
}

/** Maps a back office action key to the translation key of its user-friendly label. */
export const BackofficeActionLabelKeys: Record<string, string> = {
  CREATE_WOH: 'boActionCreateWohText',
  CREATE_WOL: 'boActionCreateWolText',
  DELETE_WOL: 'boActionDeleteWolText',
  DELETE_WOH: 'boActionDeleteWohText',
  CUSTOMER: 'boActionCustomerText',
  PRODUCTION_CUST: 'boActionProductionCustText',
  WOHNUM: 'boActionWohnumText',
  WOH_NUM: 'boActionWohNumText',
  DUE_DATE: 'boActionDueDateText',
  RECEIVED_DATE: 'boActionReceivedDateText',
  CRN: 'boActionCrnText',
  FISCAL_ID_NUM: 'boActionFiscalIdNumText',
  SITE: 'boActionSiteText',
  PLANT: 'boActionPlantText',
  CIRCUMFERENCE: 'boActionCircumferenceText',
  TREAD_WIDTH: 'boActionTreadWidthText',
  DEPTH: 'boActionDepthText',
  REMAINING_TREAD_DEPTH: 'boActionRemainingTreadDepthText',
  CASING_NOTE: 'boActionCasingNoteText',
  CASING_VALUE: 'boActionCasingValueText',
  CASING_ID: 'boActionCasingIdText',
  TREAD_TYPE: 'boActionTreadTypeText',
  CURE_TYPE: 'boActionCureTypeText',
  MAKE: 'boActionMakeText',
  SERIES: 'boActionSeriesText',
  SIZE: 'boActionSizeText',
  APPLICATION: 'boActionApplicationText',
  AXLE: 'boActionAxleText',
  MDOT: 'boActionMdotText',
  RTDOT: 'boActionRtdotText',
  BRAND_NUM: 'boActionBrandNumText',
  WHEEL_COLOR: 'boActionWheelColorText',
  WHEEL_TYPE: 'boActionWheelTypeText',
  GRADE: 'boActionGradeText',
  OVERRIDE_GRADE: 'boActionOverrideGradeText',
  CAM: 'boActionCamText',
  NTR: 'boActionNtrText',
  PROCESS_CODE: 'boActionProcessCodeText',
  REPAIR: 'boActionRepairText',
  MISC_CHARGE: 'boActionMiscChargeText'
};

/**
 * Builds dropdown options from every known action key (legacy list + mapped keys).
 * Keys without a mapped label fall back to the key itself.
 */
export function buildBackofficeActionOptions(translate: (key: string) => string): BackofficeActionOption[] {
  const keys = Array.from(new Set([...BackofficeActionState, ...Object.keys(BackofficeActionLabelKeys)]));
  return keys.map((key) => {
    const labelKey = BackofficeActionLabelKeys[key];
    return { key, label: labelKey ? translate(labelKey) : key };
  });
}
